import { createSelector } from '@reduxjs/toolkit';

import filtersChoiceSelector from '@/features/choice/selectors/filters';
import flattenFilterGridItemsSelector from '@/features/config/selectors/flattenFilterGridItems';

import prepareFilterQuery from '../helpers/prepareFilterQuery';

import filtersDataSelector from './data';

const filterQueriesSelector = createSelector(
  [filtersDataSelector, filtersChoiceSelector, flattenFilterGridItemsSelector],
  (filtersData, filtersChoice, filterGridItems) => {
    const q: string[] = [];
    const qMap: Record<string, string> = {};

    const { data: filtersRawItem } = filtersData;

    // Для формирования queries доступных значений фильтров необходимо
    // получить данные о всех фильтрах
    if (!filtersRawItem) {
      return { q, qMap };
    }

    if (filterGridItems.length) {
      filterGridItems.forEach(item => {
        const query = prepareFilterQuery(
          item,
          filtersRawItem.data?.[item.key],
          filtersChoice?.[item.key],
        );
        if (query) {
          q.push(query);
          qMap[item.key] = query;
        }
      });
    }

    return { q, qMap };
  },
);

export default filterQueriesSelector;
